/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ResyncOutcome } from "./ResyncOutcome";
import {
  ResyncOutcomeFromJSON,
  ResyncOutcomeFromJSONTyped,
  ResyncOutcomeToJSON,
  ResyncOutcomeToJSONTyped,
} from "./ResyncOutcome";

/**
 *
 * @export
 * @interface ResyncResult
 */
export interface ResyncResult {
  /**
   *
   * @type {string}
   * @memberof ResyncResult
   */
  trackingId: string;
  /**
   *
   * @type {ResyncOutcome}
   * @memberof ResyncResult
   */
  outcome: ResyncOutcome;
  /**
   *
   * @type {string}
   * @memberof ResyncResult
   */
  detail: string;
}

/**
 * Check if a given object implements the ResyncResult interface.
 */
export function instanceOfResyncResult(value: object): value is ResyncResult {
  if (!("trackingId" in value) || value["trackingId"] === undefined)
    return false;
  if (!("outcome" in value) || value["outcome"] === undefined) return false;
  if (!("detail" in value) || value["detail"] === undefined) return false;
  return true;
}

export function ResyncResultFromJSON(json: any): ResyncResult {
  return ResyncResultFromJSONTyped(json, false);
}

export function ResyncResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResyncResult {
  if (json == null) {
    return json;
  }
  return {
    trackingId: json["trackingId"],
    outcome: ResyncOutcomeFromJSON(json["outcome"]),
    detail: json["detail"],
  };
}

export function ResyncResultToJSON(json: any): ResyncResult {
  return ResyncResultToJSONTyped(json, false);
}

export function ResyncResultToJSONTyped(
  value?: ResyncResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    trackingId: value["trackingId"],
    outcome: ResyncOutcomeToJSON(value["outcome"]),
    detail: value["detail"],
  };
}
